import { FormattedMessage } from "react-intl";
import { Alert, Button, Card } from "@mui/material";

export interface EmManualControlCardErrorTemplateProps {
	readonly onRetry: () => void;
}

export const EmManualControlCardErrorTemplate = ({ onRetry }: EmManualControlCardErrorTemplateProps) => (
	<Card variant="outlined" data-testid="em-manual-control-card__error__machine">
		<Alert
			severity="error"
			action={
				<Button color="inherit" size="small" onClick={onRetry}>
					<FormattedMessage id="Retry" defaultMessage="Retry" />
				</Button>
			}
			sx={{ m: 2 }}
		>
			<FormattedMessage
				id="We couldn't load the EM machine. Please try again."
				defaultMessage="We couldn't load the EM machine. Please try again."
			/>
		</Alert>
	</Card>
);
